import { render, staticRenderFns } from "./TerminRaumUpdateModal.vue?vue&type=template&id=5d127e06&"
import script from "./TerminRaumUpdateModal.vue?vue&type=script&lang=js&"
export * from "./TerminRaumUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports